<script>
export default {
  computed: {
    unit() {
      if (this.$fischer.lengthUnit() === 'miles') {
        return this.$dict.get('online-Shop.Global-Labels.Length-Units.Miles');
      }

      return this.$dict.get('online-Shop.Global-Labels.Length-Units.Kilometres');
    },
  },
  methods: {
    roundDistance(distance) {
      if (!distance || distance === null) {
        return 0;
      }
      if (distance > 10) {
        return Math.round(distance);
      }
      return distance.toLocaleString(undefined, {
        maximumFractionDigits: 1,
        minimumFractionDigits: 0,
      });
    },
    lengthUnitDistance(distance) {
      // calculate metre distance in unit of length
      if (this.$fischer.lengthUnit() === 'miles') {
        return this.roundDistance(distance * 1609.34);
      }

      return distance * 1000;
    },
  },
};
</script>
